import { gql } from "@apollo/client";

export const organizationsAvailableForLensSpaceCreationFragment = gql`
    fragment OrganizationsAvailableForLensSpaceCreation on MyLensesGetOrganizationsResponse {
        organizationsList {
            id
            name
        }
    }
`;
